import { createTheming } from 'react-jss';
import injectSheet from "react-jss";

export const theming = createTheming('__customTheme__');
export const { channel, withTheme: withCustomTheme, ThemeProvider: CustomThemeProvider, themeListener } = theming;

export const customTheme = (styles, component) => {
    return withCustomTheme(injectSheet(styles, { theming })(component));
}



// WEBPACK FOOTER //
// ./src/themeProvider.js